import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

import { ContactSearchService } from '../../../services/contacts/contact-search.service';

@Component({
  selector: 'app-recipient-search',
  templateUrl: './recipient-search.component.html',
  styleUrls: ['./recipient-search.component.css'],
})
export class RecipientSearchComponent implements OnInit, OnChanges {
  recipientSearchTerm: string;

  @Input() include_item: boolean = false;
  @Input() recipientId: number | undefined;
  @Input() small_input: boolean = false;
  @Input() editable: boolean = true;
  @Input() placeholder: string;
  @Output() recipient_id: EventEmitter<string> = new EventEmitter();
  @Input() select_only: boolean = false;
  @Output() recipient: EventEmitter<any> = new EventEmitter();
  @Output() clearRecipient: EventEmitter<any> = new EventEmitter();

  constructor(private contactSearchService: ContactSearchService) {}

  // Component lifecycle events

  ngOnInit() {}

  ngOnChanges(changes: any) {
    if (changes.recipientId && changes.recipientId.currentValue && !this.select_only)
      this.contactSearchService.getContactInfo(this.recipientId!).then((response_json) => {
        this.recipientSearchTerm = response_json.name;
      });
    else if (this.select_only) this.recipientSearchTerm = '';
  }

  // Component methods

  clearSelectedRecipient(): void {
    this.recipientId = undefined;
    this.recipientSearchTerm = '';
    this.clearRecipient.emit('clearRecipient');
  }

  recipientSearchOnSelect(item: any): void {
    if (this.include_item) this.recipientId = item.id;
    else this.recipientId = item;
    if (this.select_only) {
      let scope = this;
      this.recipient.emit(item);
      window.setTimeout(function () {
        scope.recipientSearchTerm = '';
      }, 100);
    } else if (this.include_item) {
      this.recipient.emit(item);
      this.recipient_id.emit(String(item.id));
    } else this.recipient_id.emit(String(item));
  }
}
